/** When your routing table is too long, you can split it into small modules**/

export default {
  title: '簡易共用表格',
  to: {
    path: '/erp/de/select/view/de-table',
  },
  action: 'manage',
  subject: 'DESELECT',
}
